/**
 * Product Filter — category tab switching
 */
export const productFilter = {
    selector: '[data-product-filter-tabs]',

    init() {
        document.querySelectorAll( this.selector ).forEach( tabsContainer => {
            const section    = tabsContainer.closest( 'section' );
            const buttons    = tabsContainer.querySelectorAll( '[data-filter]' );
            const categories = section?.querySelectorAll( '[data-product-category]' );

            if ( ! buttons.length || ! categories?.length ) return;

            buttons.forEach( btn => {
                btn.addEventListener( 'click', () => {
                    const filter = btn.dataset.filter;

                    // Update active tab styles
                    buttons.forEach( b => {
                        b.classList.remove( 'bg-brand', 'text-white' );
                        b.classList.add( 'bg-warm-gray', 'text-text-mid' );
                    } );
                    btn.classList.remove( 'bg-warm-gray', 'text-text-mid' );
                    btn.classList.add( 'bg-brand', 'text-white' );

                    // Show/hide categories
                    categories.forEach( cat => {
                        if ( filter === 'all' || cat.dataset.productCategory === filter ) {
                            cat.style.display = '';
                        } else {
                            cat.style.display = 'none';
                        }
                    } );
                } );
            } );
        } );
    },
};
